// インサイトタブで使用するフロント側のステージ表示定義。
// API のレスポンスはキーと値のみで色やラベル順を持たないため、
// 表示に必要な色・順序・列定義をここで集約する。

export interface InsightStageStyle {
  key: string;
  label: string;
  color: string;
}

/**
 * リードタイム積み上げバーで表示するステージ（Figma 配色）。
 *
 * グループ表示（担当者別）・非グループ表示（組織全体）ともに登録を除く6ステージ
 * （CA面談以降）を、同一の配色で表示する。
 * 色はすべて Primitive/Gray|Blue トークンと一致する。
 */
export const LEAD_TIME_BAR_STAGES_GROUPED: InsightStageStyle[] = [
  { key: 'ca_meeting', label: 'CA面談', color: '#B0B0B0' }, // Primitive/Gray/300
  { key: 'document_screening', label: '書類選考', color: '#888888' }, // Primitive/Gray/400
  { key: 'screening', label: '選考', color: '#0E295D' }, // Primitive/Blue/950
  { key: 'final_meeting', label: '最終面接', color: '#0849C5' }, // Primitive/Blue/800
  { key: 'offered', label: '内定', color: '#0674FF' }, // Primitive/Blue/600
  { key: 'closed', label: '決定', color: '#48B7FF' }, // Primitive/Blue/400
];

// 非グループ表示も登録を含まず、グループ表示と同一の配色で表示する。
// グループ表示と完全に同一のため、ドリフト防止のためグループ定義をエイリアスする。
export const LEAD_TIME_BAR_STAGES_UNGROUPED = LEAD_TIME_BAR_STAGES_GROUPED;

/** 後方互換のため、既存参照（グループ時の色順序）を旧名でも公開する。 */
export const LEAD_TIME_BAR_STAGES = LEAD_TIME_BAR_STAGES_GROUPED;

/** 進捗別ファネル図のステージ表示順とラベル */
export const FUNNEL_STAGE_LABELS: Record<string, string> = {
  registration: '登録',
  ca_meeting: 'CA面談',
  document_screening: '書類選考',
  screening: '選考',
  final_meeting: '最終面接',
  offered: '内定',
  closed: '決定',
};

/** 担当者別テーブルの列順とヘッダー名（Figma準拠で「最終面談」表記） */
export const CONSULTANT_TABLE_COLUMNS: { key: string; label: string }[] = [
  { key: 'ca_meeting', label: 'CA面談' },
  { key: 'suggest', label: '求人提案' },
  { key: 'document_screening', label: '書類選考' },
  { key: 'screening', label: '選考' },
  { key: 'final_meeting', label: '最終面談' },
  { key: 'offered', label: '内定' },
  { key: 'closed', label: '決定' },
];

/** トレンドチャートで担当者別シリーズに割り当てる色パレット（Figma 準拠の3色を起点に循環） */
export const TREND_GROUPED_COLORS = [
  '#0e295d',
  '#0849c5',
  '#48b7ff',
  '#0674ff',
  '#7f7f7f',
  '#b5e2ff',
];

/** 系列名から決定的に色を割り当てる（順序は trend.series の登場順） */
export function trendColorForIndex(index: number): string {
  return TREND_GROUPED_COLORS[index % TREND_GROUPED_COLORS.length];
}
